// extracted by mini-css-extract-plugin
module.exports = {"submit":"styles_submit__GkOa7","list":"styles_list__2JOk5","list-item":"styles_list-item__YMq_t"};